<template>
    <Layout :pagetitle="'裝置分組權限指派'">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title mb-0">裝置分組權限指派</h4>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12">
                            <div class="mt-4 mt-xl-0">
                                <h5 class="font-size-14 mb-4">
                                    <i class="mdi mdi-arrow-right text-primary me-1"></i>基本資訊
                                </h5>

                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="form-label" for="financial-address">裝置分組代碼</label>
                                        <div>
                                            <span>{{ form.groupCode }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label" for="financial-address">裝置分組名稱</label>
                                        <div>
                                            <span>{{ form.groupName }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="mb-3">
                                            <label class="form-label" for="financial-address">描述</label>
                                            <div>
                                                <span>{{ form.description }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-4">
                                        <button type="button" @click.prevent="assign" :disabled="isCloseBtn"
                                                class="btn btn-primary">
                                            進入指派功能
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <h5 class="font-size-14 mb-4">
                                        <i class="mdi mdi-arrow-right text-primary me-1"></i>擁有權限清單
                                    </h5>
                                    <div class="row">
                                        <Grid :style="{ height: '100%' }" :data-items="ownScopeGrid.result"
                                              :selected-field="ownScopeGrid.selectedField" :sortable="true"
                                              :pageable="{ refresh: true, pageSizes: [10, 25, 50, 100], buttonCount: 5 }"
                                              :scrollable="'none'"
                                              :filterable="false" :filter="ownScopeGrid.filter"
                                              :sort="ownScopeGrid.sort" :skip="ownScopeGrid.skip"
                                              :take="ownScopeGrid.take" :total="ownScopeGrid.total" :columns="columns"
                                              @selectionchange="onSelectionChange"
                                              @headerselectionchange="onHeaderSelectionChange" @rowclick="onRowClick"
                                              @pagechange="pageChangeHandler">
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <button type="submit" @click.prevent="remoceScope" :disabled="isCloseBtn"
                                            class="btn btn-danger">移除選取的權限
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="col-lg-12">
                            <div class="mt-4 mt-xl-0">
                                <div class="row d-flex justify-content-between">
                                    <div class="hstack gap-3">
                                        <button type="button" @click.prevent="back" :disabled="isCloseBtn"
                                                class="btn btn-primary">上一頁
                                        </button>
                                        <div class="vr"></div>

                                    </div>
                                    <div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import {useRoute, useRouter} from 'vue-router';
import Layout from "../../layouts/main";
import {ref, onMounted} from "vue";
import {Grid} from "@progress/kendo-vue-grid";
import {toDataSourceRequestString} from "@progress/kendo-data-query";
import axios from 'axios';
//import { backendAPI } from "../../../components/commons/axiosBackendApj";


const findGroup = async (groupCode) => {
    const quer_url = '/api/FindGroup'
    const init_data = {method: 'GET', accept: 'application/json', headers: {}};
    let group = await fetch(`${quer_url}?groupCode=${groupCode}`, init_data)
        .then(response => response.json());

    return {groupName: group.value.groupName, description: group.value.description}
}


const fetchData = async (dataState) => {
    const queryStr = `${toDataSourceRequestString(dataState)}`; // Serialize the state
    const base_url = "/api/QueryGroupOwnScope";
    const init = {method: "GET", accept: "application/json", headers: {}};
    let fetchResult = await fetch(`${base_url}?${queryStr}`, init)
        .then((response) => response.json())
        .then(({data, total}) => {
            let result = data.map((item) => {
                return {...item, selected: false};
            });
            return {result: result, total: total};
        });

    return fetchResult;
};


export default {

    setup() {

        const route = useRoute();
        const router = useRouter();
        const groupCode = route.params.id;

        const form = ref({
            groupCode: groupCode,
            groupName: "",
            description: ""
        });

        const ownScopeGrid = ref({
            selectedField: "selected",
            sort: null,
            filter: {
                logic: "and",
                filters: [{
                    field: "groupCode",
                    operator: "eq",
                    value: groupCode,
                }],
            },
            result: [],
            skip: 0,
            take: 10,
            total: 0,
            staticColumns: [
                {field: "description", title: "功能描述"},
                {field: "scopeCode", title: "代號"},
                {field: "scopeName", title: "名稱"},

            ],
            formSelected: [],
        });

        onMounted(async () => {

            let formData = await findGroup(groupCode);
            form.value.groupName = formData.groupName;
            form.value.description = formData.description;

            //fetch data
            let dataState = {
                skip: ownScopeGrid.value.skip,
                take: ownScopeGrid.value.take,
                filter: ownScopeGrid.value.filter
            };
            let fetchResult = await fetchData(dataState);

            ownScopeGrid.value.result = fetchResult.result;
            ownScopeGrid.value.total = fetchResult.total;
            // console.log(fetchResult);

        });

        const isCloseBtn = ref(false);
        return {
            ownScopeGrid,
            form,
            isCloseBtn,
            router
        };
    },
    components: {
        Layout,
        Grid
    },
    computed: {
        areAllSelected() {
            return this.ownScopeGrid.result.findIndex((item) => item.selected === false) === -1;
        },
        columns() {
            return [
                {
                    field: "selected",
                    width: "50px",
                    headerSelectionValue: this.areAllSelected,
                },
                ...this.ownScopeGrid.staticColumns,
            ];
        },
    },
    methods: {
        fetchData: async function (dataState) {
            let data = await fetchData(dataState);
            this.ownScopeGrid.result = data.result;
            this.ownScopeGrid.total = data.total;
        },
        pageChangeHandler: function (event) {
            setTimeout(() => {
                this.ownScopeGrid.skip = event.page.skip;
                this.ownScopeGrid.take = event.page.take;
                this.fetchData({
                    skip: this.ownScopeGrid.skip,
                    take: this.ownScopeGrid.take,
                    filter: this.ownScopeGrid.filter
                });
            }, 300);
        },
        onHeaderSelectionChange(event) {
            let checked = event.event.target.checked;
            this.ownScopeGrid.result = this.ownScopeGrid.result.map((item) => {
                return {...item, selected: checked};
            });
            this.ownScopeGrid.result.forEach((element) => {
                this.changeApplyFormSelected(element.scopeCode, element.selected);
            });
        },
        onSelectionChange(event) {
            event.dataItem[this.ownScopeGrid.selectedField] = !event.dataItem[this.ownScopeGrid.selectedField];
            let scopeCode = event.dataItem["scopeCode"];
            this.changeApplyFormSelected(scopeCode, event.dataItem[this.ownScopeGrid.selectedField]);
        },
        onRowClick(event) {
            event.dataItem[this.ownScopeGrid.selectedField] = !event.dataItem[this.ownScopeGrid.selectedField];
            let scopeCode = event.dataItem["scopeCode"];
            this.changeApplyFormSelected(scopeCode, event.dataItem[this.ownScopeGrid.selectedField]);
        },
        changeApplyFormSelected(scopeCode, isSelected) {
            if (isSelected) {
                if (!this.ownScopeGrid.formSelected.includes(scopeCode)) {
                    this.ownScopeGrid.formSelected.push(scopeCode);
                }
            } else {
                if (this.ownScopeGrid.formSelected.includes(scopeCode)) {
                    this.ownScopeGrid.formSelected = this.ownScopeGrid.formSelected.filter((x) => x != scopeCode);
                }
            }
        },
        back() {
            this.router.push({name: 'group-list'});
        },
        assign() {
            let groupCode = this.form.groupCode;
            this.router.push({name: 'group-assign-scope', params: {id: groupCode}});
        },
        remoceScope() {
            let form = {
                ScopeCodes: this.ownScopeGrid.formSelected,
                GroupCode: this.form.groupCode
            };
            axios({
                method: "post",
                url: "/api/RemoveGroupScope",
                headers: {
                    "content-type": "application/json",
                },
                data: form,
            })
                .then((response) => {
                    console.log(response);
                    this.fetchData({
                        skip: this.ownScopeGrid.skip,
                        take: this.ownScopeGrid.take,
                        filter: this.ownScopeGrid.filter
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.fetchData({
                        skip: this.ownScopeGrid.skip,
                        take: this.ownScopeGrid.take,
                        filter: this.ownScopeGrid.filter
                    });
                });
            this.ownScopeGrid.formSelected = [];
        }

    },
};
</script>
